import styles from "./request-form.module.css";

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { Flex, Typography, Card, message, Skeleton } from "antd";

import { getMe } from "@/api/auth";

import RequestModal from "@/components/modals/RequestModal";

import { getFormItem } from "@/api/requests";
import FlexibleRequestForm from "@/components/forms/FlexibleRequestForm";

const { Title, Text } = Typography;

const isValidEmail = (value) => {
  if (!value || typeof value !== "string") return false;

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
};

const getValidUserEmail = (secondaryEmail, email) => {
  if (isValidEmail(secondaryEmail)) return secondaryEmail.trim();
  if (isValidEmail(email)) return email.trim();

  return "";
};

const PreviewForm = () => {
  const { uuid, id } = useParams();

  const [formData, setFormData] = useState(null);
  const [unitInfo, setUnitInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [newRequest, setNewRequest] = useState(null);
  const [isModalShow, setIsModalShow] = useState(false);
  const [requestType, setRequestType] = useState(null);

  const fetchData = async () => {
    setIsLoading(true);

    let requestTypeData = {};
    try {
      requestTypeData = await getFormItem({ uuid: uuid }, true);
      setRequestType(requestTypeData);
      if (id === "default") {
        setUnitInfo({
          unit_displayed_name: "[ Название подразделения ]",
          comment: "[ Комментарий ]",
        });
      } else {
        const unit = requestTypeData?.units?.find(
          (item) => item.unit_uuid === id,
        );
        setUnitInfo(unit);
      }
    } catch (error) {
      message.error(`Не удалось загрузить данные типа заявки: ${error}`);
      setRequestType(null);
    }

    try {
      const fetchedData = await getMe();
      const { email, secondary_email, lastname, firstname, patronymic, employee_uuid } =
        fetchedData.user;
      setFormData({
        user_email: getValidUserEmail(secondary_email, email),
        user_name:
          `${lastname || ""} ${firstname || ""} ${patronymic || ""}`.trim(),
        recipient_uuid: employee_uuid,
        unit_uuid: id,
        request_type_uuid: requestTypeData?.uuid ?? null,
      });
    } catch (error) {
      setFormData({
        user_email: "",
        user_name: "",
        recipient_uuid: null,
        unit_uuid: id,
        request_type_uuid: requestTypeData?.uuid ?? null,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // initial fetch
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id]);

  const handleSave = async (request) => {
    if (request) {
      setNewRequest(request);
      setIsModalShow(true);
    }
  };

  const modalClose = () => {
    setIsModalShow(false);
    setNewRequest(null);

    window.close(); // Закрываем вкладку
  };

  return (
    <>
      <Flex vertical gap={20} className={styles.card_wrap}>
        <Text strong type="secondary">
          Предпросмотр формы заявки
        </Text>
        <Card variant="borderless" className={styles.card}>
          <Flex vertical gap={25}>
            {isLoading ? (
              <Flex vertical align="center" className={styles.spin}>
                <div className="spin">
                  <Skeleton size="large" active />
                </div>
              </Flex>
            ) : (
              <>
                <Flex vertical gap={15}>
                  <Title level={5} style={{ margin: 0, textAlign: "end" }}>
                    {unitInfo?.unit_displayed_name}
                  </Title>
                  <Title level={2} style={{ margin: 0, textAlign: "center" }}>
                    {requestType?.name}
                  </Title>
                </Flex>
                <Text type="secondary">{unitInfo?.comment}</Text>
                <FlexibleRequestForm
                  isPreview
                  onSave={handleSave}
                  data={{ ...formData, ...requestType }}
                />
              </>
            )}
          </Flex>
        </Card>
      </Flex>

      {isModalShow && (
        <RequestModal
          data={newRequest}
          visible={isModalShow}
          onCancel={modalClose}
        />
      )}
    </>
  );
};

export default PreviewForm;
